/**
 * PWA Push Notification utilities
 */

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api/v1` : '/api/v1';

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.log('[PWA] Service workers not supported');
    return null;
  }
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    console.log('[PWA] Service worker registered');
    return reg;
  } catch (error) {
    console.error('[PWA] SW registration failed:', error);
    return null;
  }
}

export async function subscribeToPush(token) {
  if (!('PushManager' in window)) {
    console.log('[PWA] Push not supported');
    return false;
  }

  try {
    const reg = await navigator.serviceWorker.ready;
    
    // Get VAPID key from backend
    let vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
    if (!vapidKey) {
      try {
        const res = await fetch(`${API}/push/vapid-key`);
        const data = await res.json();
        vapidKey = data.public_key;
      } catch (e) {
        console.error('[PWA] Failed to get VAPID key');
        return false;
      }
    }

    if (!vapidKey) {
      console.log('[PWA] No VAPID key available');
      return false;
    }

    const existing = await reg.pushManager.getSubscription();
    if (existing) {
      // Already subscribed, just ensure backend knows
      await sendSubscriptionToBackend(existing, token);
      return true;
    }

    const subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey)
    });

    await sendSubscriptionToBackend(subscription, token);
    console.log('[PWA] Push subscription created');
    return true;
  } catch (error) {
    console.error('[PWA] Push subscription failed:', error);
    return false;
  }
}

export async function unsubscribeFromPush(token) {
  try {
    const reg = await navigator.serviceWorker.ready;
    const subscription = await reg.pushManager.getSubscription();
    if (subscription) {
      // Tell backend
      await fetch(`${API}/push/unsubscribe?endpoint=${encodeURIComponent(subscription.endpoint)}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      await subscription.unsubscribe();
    }
    return true;
  } catch (error) {
    console.error('[PWA] Unsubscribe failed:', error);
    return false;
  }
}

export async function isPushSubscribed() {
  if (!('PushManager' in window) || !('serviceWorker' in navigator)) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}

async function sendSubscriptionToBackend(subscription, token) {
  const sub = subscription.toJSON();
  await fetch(`${API}/push/subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      endpoint: sub.endpoint,
      keys: sub.keys
    })
  });
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
}
